import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SideNavComponent } from '@tgbot/app/components/side-nav/side-nav.component';

@Component({
  selector: 'crm-tgbot-shell',
  imports: [RouterOutlet, SideNavComponent],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {}
